// Flat form-field defaults for the reusable EntityTaxInformationSection.
// Spread these into a form's DEFAULT_VALUES so every tax field stays controlled.
export const ENTITY_TAX_INFORMATION_DEFAULT_VALUES = {
  taxIdentificationNumber: "",
  taxpayerName: "",
  identityNumber: "",
  defaultTaxIncluded: false,
  taxInformationAddress: "",
  taxInformationPostalCode: "",
  taxInformationCity: "",
  taxInformationProvince: "",
  taxInformationCountry: "",
};

// Flat form fields -> `entityTaxInformation` request payload.
export const mapEntityTaxInformationToPayload = (formData) => ({
  taxIdentificationNumber: formData.taxIdentificationNumber || null,
  taxpayerName: formData.taxpayerName || null,
  identityNumber: formData.identityNumber || null,
  defaultTaxIncluded: formData.defaultTaxIncluded,
  address: formData.taxInformationAddress || null,
  postalCode: formData.taxInformationPostalCode || null,
  city: formData.taxInformationCity || null,
  province: formData.taxInformationProvince || null,
  country: formData.taxInformationCountry || null,
});

// `entityTaxInformation` response object -> flat form fields (null-safe: an
// entity may not have tax information yet).
export const mapEntityTaxInformationToFormValues = (entityTaxInformation) => ({
  taxIdentificationNumber: entityTaxInformation?.taxIdentificationNumber || "",
  taxpayerName: entityTaxInformation?.taxpayerName || "",
  identityNumber: entityTaxInformation?.identityNumber || "",
  defaultTaxIncluded: entityTaxInformation?.defaultTaxIncluded ?? false,
  taxInformationAddress: entityTaxInformation?.address || "",
  taxInformationPostalCode: entityTaxInformation?.postalCode || "",
  taxInformationCity: entityTaxInformation?.city || "",
  taxInformationProvince: entityTaxInformation?.province || "",
  taxInformationCountry: entityTaxInformation?.country || "",
});
